// --- 共通 ---
let desiredQty = 1;

function readSelectQty() {
  let total = 0;
  $('.suitcase-number select').each(function () {
    const v = parseInt($(this).val(), 10);
    if (Number.isFinite(v)) total += v;
  });
  return total > 0 ? total : 1;
}

function nativeSet(el, n) {
  const setter = Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set;
  setter.call(el, n);
  el.setAttribute('value', String(n)); // 属性側も同期（テーマ依存対策）
}

function forceQtyFor(ms = 1200) {
  const start = performance.now();
  function tick() {
    const el = document.querySelector('.quantity__input');
    if (el && el.value !== String(desiredQty)) nativeSet(el, desiredQty);
    if (performance.now() - start < ms) {
      requestAnimationFrame(tick);
    } else {
      // 最後に1回だけイベント（UI同期用）
      if (el) {
        el.dispatchEvent(new Event('input',  { bubbles: true }));
        el.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }
  requestAnimationFrame(tick);
}

// --- スーツケース数 select を変えた時 ---
$(document).on('change', '.suitcase-number select', function () {
  desiredQty = readSelectQty();
  // 再描画が無い前提なので短め
  forceQtyFor(300);
});

// --- 配送エリアのラジオを変えた時 ---
$(document).on('change', '.delivery-area input[type=radio]', function(){
  desiredQty = readSelectQty(); // いまの希望数量を覚える

  const m = $(this).val().match(/【(.+?)】/);
  if (m) {
    const area = m[1];
    $(`.product__block--variant_picker input[type="radio"][value="${area}"] + label`).click();
  }

  // バリアント変更による quantity 差し替えに対抗して1.2秒だけ上書きを継続
  forceQtyFor(1200);
});
// --- プランのラジオを変えた時 ---
$(document).on('change', '.plan input[type=radio]', function(){
  const m = $(this).val();
  console.log("value:" + m);
  if (m) {
    const area = m[1];
    $(".product__block--variant_picker input[value='"+ m +"'] + label").click();
  }
});